<template>
    <div class="container-fluid" id="featured-adoptee-banner">
        <div class="row h-100 justify-content-center align-items-center">
            <div class="col-md-6" id="poster_left">
                <div>
                    <h1 class="wwf-font">
                        {{
                            adoptee && adoptee.featured_adoptee_banner_title
                                ? adoptee.featured_adoptee_banner_title
                                : "THEIR SURVIVAL DEPENDS ON YOU"
                        }}
                    </h1>
                    <p class="mb-5">
                        {{
                            adoptee && adoptee.featured_adoptee_banner_lead_text
                                ? adoptee.featured_adoptee_banner_lead_text
                                : "Help us protect the remaining less than 200 tigers in Malaysia. One bold action from you will have a much wider impact for wildlife and people."
                        }}
                    </p>
                    <a
                        :href="
                            adoptee && adoptee.featured_adoptee_banner_btn_link
                                ? adoptee.featured_adoptee_banner_btn_link
                                : '/'
                        "
                        style="border-radius: 7px"
                        >{{
                            adoptee && adoptee.featured_adoptee_banner_btn_text
                                ? adoptee.featured_adoptee_banner_btn_text
                                : "BE A TIGER PROTECTOR  >"
                        }}</a
                    >
                    <!-- "BE A TIGER PROTECTOR >" -->
                </div>
            </div>
            <div class="col-md-6 img-left order-md-2 p-0">
                <img
                    width="100%;"
                    style="min-height:100%;"
                    :src="
                        adoptee && adoptee.featured_adoptee_banner_image
                            ? '/storage/' +
                              adoptee.featured_adoptee_banner_image
                            : '/storage/imgs/tigers/Medium_WW128769.jpg'
                    "
                />
                <!-- 'imgs/tigers/Medium_WW128769.jpg' -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            adoptee: []
        };
    },
    mounted() {
        axios.get("/api/v1/adoptees/featured").then(response => {
            this.adoptee = response.data.data;
        });
    }
};
</script>
<style scoped>
#featured-adoptee-banner {
    background-color: black;
    min-width: 100%;
    color: white;
}
#featured-adoptee-banner #poster_left {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 25px 150px 25px 150px;
}

#featured-adoptee-banner p {
    font-size: 1rem;
    margin-top: 20px;
}
#featured-adoptee-banner h1 {
    color: white;
    font-size: 4rem;
    line-height: 1;
}
#featured-adoptee-banner a {
    background-color: #f07d00;
    border: none;
    color: white;
    font-size: 1.6rem;
    padding: 10px 15px;
    font-family: "WWF";
}
#featured-adoptee-banner a:hover {
    text-decoration: none;
}
@media only screen and (max-width: 768px) {
    #featured-adoptee-banner #poster_left {
        padding: 3em;
        padding-bottom: 4em;
    }
    #featured-adoptee-banner p {
        font-size: 1rem;
    }
    #featured-adoptee-banner h1 {
        font-size: 3rem;
        margin-top: 25px;
    }
    #featured-adoptee-banner a {
        font-size: 1.3rem;
    }
}
</style>
